import { DBDef_NLPData, DBDef_Reference, DBDef_Tag, DBDef_Value, DBDef_Variable } from '@app/hcs-shared';
import { DBDef_DiseaseProfile, DBDef_DiseaseValue, DBDef_MultiVar } from '@app/dp-shared';
import { DBDef_Pathway, DBDef_PathwayState, DBDef_PathwayTransition } from '@app/pathway-shared';
export const PageKey_ID = '_id';
export const allDBTypes = [
    'Tag',
    'Variable',
    'DiseaseProfile',
    'MeasurementUnit',
    'Value',
    'Reference',
    'DiseaseView',
    'Book',
    'MultiVar',
    'DiseaseValue',
    'Pathway',
    'PathwayState',
    'PathwayTransition'
];
export const TopicAllowedCollectionNames = [
    DBDef_Value,
    DBDef_Variable,
    DBDef_Tag,
    DBDef_Reference,
    DBDef_MultiVar,
    DBDef_DiseaseProfile,
    DBDef_DiseaseValue,
    DBDef_NLPData,
    DBDef_Pathway,
    DBDef_PathwayState,
    DBDef_PathwayTransition,
].map(dbDef => dbDef.dbKey);
//# sourceMappingURL=core.js.map